$(function () {
    $('.page-products .products-form-search').on('submit', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const search = $(this).find('input').val();

        if (search.length == 0) {
            // alert('Digite alguma palavra para buscar');
            $(this).find('input').trigger('focus');
            return;
        }

        window.location = base_url + 'produtos/buscar/' + search + '#busca';
    });

    $('.page-products .btn-filter').on('click', function () {
        $('.page-products .container-filter').toggleClass('is-open');
    });

    $('.page-products .btn-filter-close').on('click', function () {
        $('.page-products .container-filter').removeClass('is-open');
    });

    function startCollapsible() {
        const collapsible = $('.page-products .collapsible');
        const trigger = collapsible.find('.collapsible-trigger');
        const content = collapsible.find('.collapsible-content');

        const contentHeight = content.height() + 10;
        content.css('height', 0 + 'px');

        trigger.on('click', function () {
            collapsible.attr('data-open', content.attr('data-open') == 'false' ? 'true' : 'false');
            content.attr('data-open', content.attr('data-open') == 'false' ? 'true' : 'false');

            if (content.attr('data-open') == 'true') {
                content.css('height', contentHeight + 'px');
            } else {
                content.css('height', 0 + 'px');
            }
        });
    }

    if ($('.page-products .collapsible').length) {
        startCollapsible();
    }
});
